const Ke = async (e) => typeof e == "function" ? await e() : e, _e = (e, o) => {
  if (!e) throw new Error(`orbit-bridge: \`${o}\` is required`);
}, Ne = async (e) => {
  const o = await e.text();
  if (!o) return {};
  try {
    return JSON.parse(o);
  } catch {
    throw new Error(`orbit-bridge: invalid JSON response (${e.status})`);
  }
}, Le = (e, o) => {
  if (!e || typeof e != "object") return o;
  const t = e, s = typeof t.error == "string" ? t.error : o, a = typeof t.detail == "string" ? t.detail : "";
  return a ? `${s} - ${a}` : s;
}, it = (e) => {
  if (_e(e.endpoint, "endpoint"), _e(e.anonKey, "anonKey"), !e.token) throw new Error("orbit-bridge: `token` is required");
  const o = e.fetch ?? globalThis.fetch;
  if (!o) throw new Error("orbit-bridge: fetch is not available");
  const t = async (i, u = {}) => {
    if (!i.trim()) throw new Error("orbit-bridge: action is required");
    const y = await Ke(e.token), m = await o(e.endpoint, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        apikey: e.anonKey,
        authorization: `Bearer ${e.anonKey}`
      },
      body: JSON.stringify({
        action: i,
        tenant_jwt: y,
        payload: u
      }),
      credentials: "omit",
      mode: "cors"
    }), c = await Ne(m);
    if (!m.ok)
      throw new Error(`orbit-bridge: ${Le(c, m.statusText)}`);
    return c;
  }, s = (i) => t("commands.poll", { ...i }), a = (i) => t("commands.ack", { ...i });
  return {
    call: t,
    whoami: () => t("session.whoami"),
    track: (i, u = {}, y = {}) => {
      if (!i.trim()) throw new Error("orbit-bridge: event name is required");
      return t("events.track", {
        name: i,
        payload: u,
        metadata: y.metadata ?? {}
      });
    },
    messages: {
      post: (i) => t("messages.post", { ...i }),
      list: (i = {}) => t("messages.list", { ...i }),
      subscribe: (i, u = {}) => {
        const y = /* @__PURE__ */ new Set();
        let m = !1, c = !1;
        const d = u.pollIntervalMs ?? 1e4, p = async () => {
          if (!(m || c)) {
            c = !0;
            try {
              const h = await t("messages.list", {
                conversation_id: u.conversation_id,
                since: u.since,
                limit: u.limit
              });
              for (const l of [...h.messages].reverse())
                y.has(l.id) || (y.add(l.id), i(l));
            } finally {
              c = !1;
            }
          }
        }, f = globalThis.setInterval(() => {
          p();
        }, d);
        return {
          tick: p,
          stop() {
            m = !0, globalThis.clearInterval(f);
          }
        };
      }
    },
    commands: {
      poll: s,
      ack: a,
      listen: (i, u = {}) => {
        const y = u.pollIntervalMs ?? 5e3;
        let m = !1, c = !1;
        const d = async () => {
          if (!(m || c)) {
            c = !0;
            try {
              const f = await s({
                target: u.target ?? "browser",
                limit: u.limit ?? 10,
                runner_id: u.runner_id
              });
              for (const h of f.commands)
                try {
                  const l = await i(h), w = l && typeof l == "object" ? l : {};
                  await a({
                    command_id: h.id,
                    status: "succeeded",
                    result: w
                  });
                } catch (l) {
                  await a({
                    command_id: h.id,
                    status: "failed",
                    error: l instanceof Error ? l.message : String(l)
                  });
                }
            } finally {
              c = !1;
            }
          }
        }, p = globalThis.setInterval(() => {
          d();
        }, y);
        return {
          tick: d,
          stop() {
            m = !0, globalThis.clearInterval(p);
          }
        };
      }
    },
    attachments: {
      createUpload: (i) => t("attachments.createUpload", { ...i }),
      complete: (i) => t("attachments.complete", { ...i }),
      list: (i = {}) => t("attachments.list", { ...i })
    },
    requests: {
      create: (i) => t("requests.create", { ...i }),
      list: (i = {}) => t("requests.list", { ...i })
    },
    reports: {
      create: (i) => t("reports.create", { ...i })
    },
    billing: {
      list: () => t("billing.list"),
      history: () => t("billing.history"),
      portal: (i = {}) => t("billing.portal", { ...i })
    }
  };
}, at = 2, De = [
  "version",
  "kind",
  "orgId",
  "spaceId",
  "appId",
  "installationId",
  "environmentId",
  "environment",
  "environmentKey"
], ze = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, Fe = "00000000-0000-0000-0000-000000000000";
function C(e) {
  return typeof e != "string" || !ze.test(e) || e === Fe ? null : e.toLowerCase();
}
function Je(e) {
  return e === "development" || e === "preview" || e === "staging" || e === "production";
}
function N(e) {
  const o = { ok: !1, code: "invalid_scope" };
  if (!e || typeof e != "object" || Array.isArray(e)) return o;
  const t = e;
  if (t.version !== 2)
    return { ok: !1, code: "unsupported_scope_version" };
  let s;
  switch (t.kind) {
    case "client":
      s = ["clientWorkspaceId"];
      break;
    case "product_tenant":
      s = ["ecosystemId", "productId", "productTenantId"];
      break;
    case "product_root":
      s = ["ecosystemId", "productId"];
      break;
    case "platform_root":
      s = [];
      break;
    default:
      return o;
  }
  const a = [...De, ...s];
  if (Object.keys(t).length !== a.length || a.some((c) => !Object.prototype.hasOwnProperty.call(t, c))) return o;
  const n = C(t.orgId), r = C(t.spaceId), i = C(t.appId), u = C(t.installationId), y = C(t.environmentId);
  if (!n || !r || !i || !u || !y || !Je(t.environment) || typeof t.environmentKey != "string" || !/^[a-z0-9][a-z0-9_-]{0,79}$/.test(t.environmentKey)) return o;
  const m = {
    version: 2,
    orgId: n,
    spaceId: r,
    appId: i,
    installationId: u,
    environmentId: y,
    environment: t.environment,
    environmentKey: t.environmentKey
  };
  switch (t.kind) {
    case "client": {
      const c = C(t.clientWorkspaceId);
      return c ? { ok: !0, scope: { ...m, kind: "client", clientWorkspaceId: c } } : o;
    }
    case "product_tenant": {
      const c = C(t.ecosystemId), d = C(t.productId), p = C(t.productTenantId);
      return c && d && p ? { ok: !0, scope: { ...m, kind: "product_tenant", ecosystemId: c, productId: d, productTenantId: p } } : o;
    }
    case "product_root": {
      const c = C(t.ecosystemId), d = C(t.productId);
      return c && d ? { ok: !0, scope: { ...m, kind: "product_root", ecosystemId: c, productId: d } } : o;
    }
    case "platform_root":
      return { ok: !0, scope: { ...m, kind: "platform_root" } };
    default:
      return o;
  }
}
function U(e, o) {
  const t = N(e);
  if (!t.ok) return t;
  const s = N(o);
  if (!s.ok) return s;
  const a = Object.keys(s.scope);
  return t.scope.kind !== s.scope.kind || a.some((n) => t.scope[n] !== s.scope[n]) ? { ok: !1, code: "scope_mismatch" } : s;
}
function W(e) {
  if (!e) throw new Error("invalid_attachment_response");
}
function ke(e) {
  return typeof e == "string" && /^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(e);
}
function Ve(e, o) {
  return typeof e == "number" && Number.isSafeInteger(e) && e >= o;
}
function xe(e, o) {
  W(e && typeof e == "object" && !Array.isArray(e));
  const t = e;
  return W(Object.keys(t).length === o.length && o.every((s) => Object.prototype.hasOwnProperty.call(t, s))), t;
}
const qe = 25 * 1024 * 1024, We = 50 * 1024 * 1024, Ae = 10, ue = "application/vnd.openxmlformats-officedocument.wordprocessingml.document", pe = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", Ze = ["image/png", "image/jpeg", "image/webp", "application/pdf", "text/plain", ue, pe];
function Xe(e) {
  if (["", "application/zip", "application/octet-stream"].includes(e.type)) {
    if (/\.docx$/i.test(e.name)) return ue;
    if (/\.xlsx$/i.test(e.name)) return pe;
  }
  return e.type;
}
function B(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return !1;
  const o = e;
  return typeof o.name == "string" && o.name === o.name.trim() && o.name.length > 0 && new TextEncoder().encode(o.name).length <= 200 && !Array.from(o.name).some((t) => t.charCodeAt(0) < 32 || t.charCodeAt(0) === 127 || t === "/" || t === "\\") && typeof o.type == "string" && Ze.includes(o.type) && (o.type !== ue || /\.docx$/i.test(o.name)) && (o.type !== pe || /\.xlsx$/i.test(o.name)) && Ve(o.size, 1) && o.size <= qe && typeof o.sha256 == "string" && /^[a-f0-9]{64}$/.test(o.sha256);
}
function Ge(e, o) {
  const t = xe(e, ["id", "conversationId", "messageId", "name", "type", "size", "sha256"]);
  return W(B(t) && ke(t.id) && ke(t.messageId) && t.conversationId === o), t;
}
function He(e, o, t) {
  const s = xe(e, ["version", "conversationId", "attachments"]);
  W(s.version === 1 && s.conversationId === o && Array.isArray(s.attachments) && s.attachments.length <= t.length);
  const a = /* @__PURE__ */ new Set();
  return s.attachments.map((n) => {
    const r = Ge(n, o);
    return W(t.includes(r.messageId) && !a.has(r.messageId)), a.add(r.messageId), r;
  });
}
async function ct(e) {
  const o = { name: e.name, type: Xe(e), size: e.size, sha256: "" };
  if (!B({ ...o, sha256: "0".repeat(64) })) throw new Error("invalid_attachment");
  const t = await crypto.subtle.digest("SHA-256", await e.arrayBuffer());
  return { ...o, sha256: Array.from(new Uint8Array(t), (s) => s.toString(16).padStart(2, "0")).join("") };
}
function Z(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e) ? e : null;
}
function X(e, o) {
  return e !== null && Object.keys(e).length === o.length && o.every((t) => Object.prototype.hasOwnProperty.call(e, t));
}
const ne = (e) => typeof e == "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(e) && e !== "00000000-0000-0000-0000-000000000000";
function H(e, o, t = !1) {
  return typeof e == "string" && e.trim().length > 0 && !e.includes("\0") && !Array.from(e).some((s) => {
    const a = s.codePointAt(0) ?? 0;
    return a >= 55296 && a <= 57343;
  }) && new TextEncoder().encode(e).length <= o && (!t || e === e.trim() && !Array.from(e).some((s) => (s.codePointAt(0) ?? 0) < 32 || s === ""));
}
function le(e) {
  return `${e.kind === "bug_report" ? "Bug report" : e.kind === "change_request" ? "Change request" : "Question"}: ${e.title}

${e.description}` + (e.context.path === null ? "" : `

Reported page: ${e.context.path}`) + (e.context.appVersion === null ? "" : `
Reported app build: ${e.context.appVersion}`);
}
function G(e) {
  const o = Z(e);
  if (!X(o, ["kind", "title", "description", "context"]) || typeof o.kind != "string" || !["bug_report", "change_request", "question"].includes(o.kind) || !H(o.title, 800, !0) || !H(o.description, 8e3)) return null;
  const t = Z(o.context);
  if (!X(t, ["path", "appVersion"])) return null;
  const { path: s, appVersion: a } = t;
  if (s !== null && (!H(s, 500, !0) || !s.startsWith("/") || s.startsWith("//") || s.includes("?") || s.includes("#") || s.includes("\\")) || a !== null && !H(a, 100, !0)) return null;
  const n = {
    kind: o.kind,
    title: o.title,
    description: o.description,
    context: { path: typeof s == "string" ? s : null, appVersion: typeof a == "string" ? a : null }
  };
  return new TextEncoder().encode(le(n)).length <= 1e4 ? n : null;
}
function fe(e, o, t, s) {
  const a = Z(e);
  if (!X(a, ["reportId", "conversationId", "messageId", "sequence", "scope", "input", "reportedBy", "createdAt"]) || !ne(a.reportId) || s !== void 0 && a.reportId !== s || a.conversationId !== t || !ne(a.messageId) || typeof a.sequence != "number" || !Number.isSafeInteger(a.sequence) || a.sequence < 1) return null;
  const n = G(a.input), r = o(a.scope), i = Z(a.reportedBy);
  return !n || r === null || !X(i, ["kind", "id", "issuer"]) || i.kind !== "app_user" || !ne(i.id) || typeof i.issuer != "string" || !/^https:\/\/[a-z]{20}\.supabase\.co\/auth\/v1$/.test(i.issuer) || typeof a.createdAt != "string" || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/.test(a.createdAt) || !Number.isFinite(Date.parse(a.createdAt)) || `${new Date(a.createdAt).toISOString().slice(0, 23)}${a.createdAt.slice(23, 26)}Z` !== a.createdAt ? null : {
    reportId: a.reportId,
    conversationId: t,
    messageId: a.messageId,
    sequence: a.sequence,
    scope: r,
    input: n,
    reportedBy: { kind: "app_user", id: i.id, issuer: i.issuer },
    createdAt: a.createdAt
  };
}
function ye(e) {
  return Array.isArray(e) && e.length > 0 && e.length <= 100 && e.every(ne) && new Set(e).size === e.length;
}
function Ee(e, o, t, s) {
  const a = Z(e);
  if (!X(a, ["version", "scope", "conversationId", "reports"]) || a.version !== 1 || a.conversationId !== t || !Array.isArray(a.reports) || a.reports.length > s.length || o(a.scope) === null) return null;
  const n = [], r = /* @__PURE__ */ new Set();
  let i = 0;
  for (const u of a.reports) {
    const y = fe(u, o, t);
    if (!y || !s.includes(y.messageId) || r.has(y.messageId) || y.sequence <= i) return null;
    n.push(y), r.add(y.messageId), i = y.sequence;
  }
  return n;
}
function he(e) {
  const o = G(e);
  return o !== null && new TextEncoder().encode(JSON.stringify({ action: "reports.create", conversationId: "0".repeat(36), requestKey: "0".repeat(36), report: o })).length <= 16384;
}
class g extends Error {
  constructor(o, t) {
    super(`Orbit support: ${o}`), this.code = o, this.status = t, this.name = "SupportBridgeError";
  }
}
const b = (e) => typeof e == "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(e) && e !== "00000000-0000-0000-0000-000000000000", P = (e, o = 0) => typeof e == "number" && Number.isSafeInteger(e) && e >= o, L = (e) => {
  if (!e || typeof e != "object" || Array.isArray(e)) throw new g("invalid_response");
  return e;
};
function O(e, o) {
  const t = L(e);
  if (Object.keys(t).length !== o.length || o.some((s) => !Object.prototype.hasOwnProperty.call(t, s)))
    throw new g("invalid_response");
  return t;
}
function k(e) {
  if (!e) throw new g("invalid_response");
}
const re = (e) => typeof e == "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,6})?(?:Z|[+-]\d{2}:\d{2})$/.test(e) && Number.isFinite(Date.parse(e)), ce = (e) => re(e) && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/.test(e) && `${new Date(e).toISOString().slice(0, 23)}${e.slice(23, 26)}Z` === e, M = (e, o = 1e4) => typeof e == "string" && e.trim().length > 0 && new TextEncoder().encode(e).length <= o;
function Se(e, o, t, s, a) {
  if (!M(s)) return !1;
  const n = { action: "messages.append", conversationId: o, idempotencyKey: "0".repeat(36), body: s }, r = a === "app_user" ? n : { ...n, scope: e, audience: t };
  return new TextEncoder().encode(JSON.stringify(r)).length <= 16384;
}
function z(e, o) {
  const t = O(e, ["version", "conversationId", "messageId", "sequence", "persisted", "recipientAcknowledged", "replayed"]);
  return k(t.version === 1 && t.conversationId === o && b(t.messageId) && P(t.sequence, 1) && t.persisted === !0 && t.recipientAcknowledged === !1 && typeof t.replayed == "boolean"), {
    version: 1,
    conversationId: o,
    messageId: t.messageId,
    sequence: t.sequence,
    persisted: !0,
    recipientAcknowledged: !1,
    replayed: t.replayed
  };
}
function Pe(e, o, t, s, a, n) {
  const r = O(e, ["version", "scope", "conversationId", "audience", "messages", "nextCursor", "hasMore"]);
  k(r.version === 1 && U(o, r.scope).ok && r.conversationId === t && r.audience === s && Array.isArray(r.messages) && r.messages.length <= n && typeof r.hasMore == "boolean" && (!r.hasMore || r.messages.length === n) && P(r.nextCursor, a));
  let i = a;
  const u = /* @__PURE__ */ new Set(), y = r.messages.map((m) => {
    const c = O(m, ["id", "conversationId", "sequence", "body", "createdAt", "sender"]), d = L(c.sender);
    k(b(c.id) && !u.has(c.id) && c.conversationId === t && P(c.sequence, i + 1) && M(c.body) && re(c.createdAt) && b(d.id));
    let p;
    return d.kind === "orbit_user" ? (O(d, ["kind", "id"]), p = { kind: "orbit_user", id: d.id }) : (O(d, ["kind", "id", "issuer"]), k(d.kind === "app_user" && typeof d.issuer == "string" && /^https:\/\/[a-z]{20}\.supabase\.co\/auth\/v1$/.test(d.issuer)), p = { kind: "app_user", id: d.id, issuer: d.issuer }), u.add(c.id), i = c.sequence, {
      id: c.id,
      conversationId: t,
      sequence: c.sequence,
      body: c.body,
      createdAt: c.createdAt,
      sender: p
    };
  });
  return k(r.nextCursor === i), { version: 1, scope: o, conversationId: t, audience: s, messages: y, nextCursor: i, hasMore: r.hasMore };
}
function Re(e) {
  if (e === null) return null;
  const o = O(e, ["createdAt", "conversationId"]);
  return k(ce(o.createdAt) && b(o.conversationId)), { createdAt: o.createdAt, conversationId: o.conversationId };
}
function je(e, o, t, s, a) {
  const n = O(e, ["version", "orgId", "audience", "threads", "nextCursor", "hasMore"]);
  k(n.version === 1 && n.orgId === o && n.audience === t && Array.isArray(n.threads) && n.threads.length <= a && typeof n.hasMore == "boolean" && (!n.hasMore || n.threads.length === a));
  let r = s;
  const i = /* @__PURE__ */ new Set(), u = (c) => c === null || typeof c == "string" && Array.from(c).length <= 200, y = n.threads.map((c) => {
    const d = O(c, ["conversationId", "scope", "registeredAt", "appName", "subject", "preview", "lastMessageAt"]), p = N(d.scope);
    return k(p.ok && p.scope.orgId === o && b(d.conversationId) && !i.has(d.conversationId) && ce(d.registeredAt) && typeof d.appName == "string" && d.appName.trim().length > 0 && Array.from(d.appName).length <= 200 && u(d.subject) && u(d.preview) && (d.lastMessageAt === null || ce(d.lastMessageAt)) && d.preview === null == (d.lastMessageAt === null)), k(r === null || d.registeredAt < r.createdAt || d.registeredAt === r.createdAt && d.conversationId < r.conversationId), r = { createdAt: d.registeredAt, conversationId: d.conversationId }, i.add(d.conversationId), {
      conversationId: d.conversationId,
      scope: p.scope,
      registeredAt: d.registeredAt,
      appName: d.appName,
      subject: d.subject,
      preview: d.preview,
      lastMessageAt: d.lastMessageAt
    };
  }), m = Re(n.nextCursor);
  return k((m == null ? void 0 : m.createdAt) === (r == null ? void 0 : r.createdAt) && (m == null ? void 0 : m.conversationId) === (r == null ? void 0 : r.conversationId)), { version: 1, orgId: o, audience: t, threads: y, nextCursor: m, hasMore: n.hasMore };
}
function Te(e) {
  try {
    const o = e.split(".");
    if (o.length !== 3 || !o.every((s) => /^[A-Za-z0-9_-]+$/.test(s))) throw new Error();
    const t = atob(o[1].replace(/-/g, "+").replace(/_/g, "/"));
    return L(JSON.parse(new TextDecoder("utf-8", { fatal: !0 }).decode(Uint8Array.from(t, (s) => s.charCodeAt(0)))));
  } catch {
    throw new g("unauthenticated");
  }
}
function Ce(e, o, t) {
  var d;
  let s;
  try {
    s = new URL(e.endpoint);
  } catch {
    throw new g("invalid_config");
  }
  const a = (d = /^https:\/\/([a-z]{20})\.supabase\.co$/.exec(s.origin)) == null ? void 0 : d[1];
  if (!a || !["/functions/v1/orbit-bridge", "/functions/v1/orbit-tenant-support"].includes(s.pathname) || s.search || s.hash || s.username || s.password || !/^https:\/\/[a-z]{20}\.supabase\.co\/auth\/v1$/.test(e.issuer) || !b(e.subject) || typeof e.getAccessToken != "function") throw new g("invalid_config");
  if (o === "2" && e.issuer !== `${s.origin}/auth/v1`) throw new g("invalid_config");
  if (!/^sb_publishable_[A-Za-z0-9_-]+$/.test(e.publishableKey)) {
    const p = Te(e.publishableKey);
    if (p.role !== "anon" || p.ref !== a) throw new g("invalid_config");
  }
  t !== void 0 && s.searchParams.set("environment", t);
  const n = e.timeoutMs ?? 15e3;
  if (!P(n, 100) || n > 3e4) throw new g("invalid_config");
  const r = s.href, i = e.issuer, u = e.subject, y = e.publishableKey, m = e.getAccessToken, c = e.fetch ?? globalThis.fetch;
  return async (p, f) => {
    var S;
    const h = new AbortController(), l = () => h.abort();
    if (f != null && f.aborted) throw new g("unavailable");
    f == null || f.addEventListener("abort", l, { once: !0 });
    let w = !1;
    const v = p.action === "files.download" && p.format === "binary", I = setTimeout(() => {
      w = !0, h.abort();
    }, v ? 12e4 : n);
    try {
      const A = new Promise(($, j) => h.signal.addEventListener("abort", () => j(new g(w ? "timeout" : "unavailable")), { once: !0 })), q = await Promise.race([m(), A]);
      if (!q || q.length > 16384) throw new g("unauthenticated");
      const T = Te(q);
      if (T.iss !== i || T.sub !== u) throw new g("session_changed");
      if (T.role !== "authenticated" || T.aud !== "authenticated" || !b(T.session_id) || typeof T.exp != "number" || T.exp * 1e3 <= Date.now()) throw new g("unauthenticated");
      const R = JSON.stringify(p);
      if (new TextEncoder().encode(R).length > 16384) throw new g("invalid_request");
      const E = await Promise.race([c(r, {
        method: "POST",
        credentials: "omit",
        redirect: "error",
        mode: "cors",
        signal: h.signal,
        headers: { "Content-Type": "application/json", apikey: y, Authorization: `Bearer ${q}`, "x-orbit-bridge-protocol": o },
        body: R
      }), A]);
      if (E.status !== 200)
        throw new g(E.status === 401 ? "unauthenticated" : E.status === 403 ? "forbidden" : E.status === 409 ? "conflict" : E.status === 400 ? "invalid_request" : E.status === 408 ? "timeout" : "unavailable", E.status);
      if (((S = E.headers.get("content-type")) == null ? void 0 : S.split(";")[0].trim().toLowerCase()) !== (v ? "application/octet-stream" : "application/json") || !E.body)
        throw new g("invalid_response");
      if (v) {
        const $ = E.headers.get("X-Orbit-Support-File");
        if (!$ || $.length > 2048) throw new g("invalid_response");
        let j;
        try {
          j = O(JSON.parse($), ["version", "fileId", "conversationId", "input", "messageId"]);
        } catch {
          throw new g("invalid_response");
        }
        k(j.version === 1 && j.fileId === p.fileId && j.conversationId === p.conversationId && b(j.messageId) && B(j.input));
        const ie = E.body.getReader(), ge = [];
        let F = 0;
        try {
          for (; ; ) {
            const D = await Promise.race([ie.read(), A]);
            if (D.done) break;
            if (F += D.value.length, F > j.input.size || F > qe) throw new g("invalid_response");
            ge.push(D.value);
          }
        } finally {
          ie.cancel().catch(() => {
          }), ie.releaseLock();
        }
        k(F === j.input.size);
        const ve = new Uint8Array(F);
        let Ie = 0;
        for (const D of ge)
          ve.set(D, Ie), Ie += D.length;
        return { ...j, bytes: ve };
      }
      const oe = E.body.getReader();
      let se = "", me = 0;
      const be = new TextDecoder("utf-8", { fatal: !0 });
      try {
        for (; ; ) {
          const $ = await Promise.race([oe.read(), A]);
          if ($.done) break;
          if (me += $.value.byteLength, me > 65e5) throw new g("invalid_response");
          se += be.decode($.value, { stream: !0 });
        }
        se += be.decode();
      } finally {
        oe.cancel().catch(() => {
        }), oe.releaseLock();
      }
      try {
        return JSON.parse(se);
      } catch {
        throw new g("invalid_response");
      }
    } catch (A) {
      throw A instanceof g ? A : new g(w ? "timeout" : "unavailable");
    } finally {
      clearTimeout(I), f == null || f.removeEventListener("abort", l);
    }
  };
}
function x(e) {
  if (!e) throw new g("invalid_request");
}
function Me(e, o, t) {
  const s = (n, r) => ({ action: n, conversationId: r, ...t ? { scope: t, audience: "app" } : {} }), a = (n, r, i) => {
    const u = L(n);
    return k(u.version === 1 && u.conversationId === r && b(u.fileId) && B(u.input) && (u.messageId === null || b(u.messageId)) && (!i || u.fileId === i)), { version: 1, fileId: u.fileId, conversationId: r, input: u.input, messageId: u.messageId };
  };
  return {
    async prepare(n, r, i, u) {
      x(b(n) && b(r) && B(i));
      const y = O(
        await e({ ...s("files.prepare", n), requestKey: r, file: i }, u),
        ["version", "fileId", "conversationId", "input", "messageId", "uploadUrl"]
      ), m = a(y, n);
      k(Object.keys(i).every((d) => i[d] === m.input[d]));
      let c = null;
      if (y.uploadUrl !== null) {
        k(typeof y.uploadUrl == "string");
        try {
          c = new URL(y.uploadUrl);
        } catch {
          throw new g("invalid_response");
        }
        k(c.origin === new URL(o).origin && !c.username && !c.password && !c.hash && c.pathname === "/storage/v1/object/upload/sign/orbit-support-files/" + n + "/" + m.fileId);
      }
      return k(m.messageId === null ? c !== null : y.uploadUrl === null), { ...m, uploadUrl: (c == null ? void 0 : c.href) ?? null };
    },
    async complete(n, r, i) {
      x(b(n) && b(r));
      const u = O(await e({ ...s("files.complete", n), fileId: r }, i), ["version", "fileId", "conversationId", "input", "messageId"]), y = a(u, n, r);
      return k(y.messageId !== null), y;
    },
    async lookup(n, r, i) {
      x(b(n) && ye(r));
      try {
        return He(await e({ ...s("files.forMessages", n), messageIds: r }, i), n, r);
      } catch (u) {
        throw u instanceof g ? u : new g("invalid_response");
      }
    },
    async download(n, r, i) {
      x(b(n) && b(r.id) && r.conversationId === n);
      const u = O(
        await e({ ...s("files.download", n), fileId: r.id, format: "binary" }, i),
        ["version", "fileId", "conversationId", "input", "messageId", "bytes"]
      ), y = a(u, n, r.id);
      k(y.messageId === r.messageId && B(r) && u.bytes instanceof Uint8Array && Object.keys(y.input).every((d) => y.input[d] === r[d]));
      const m = new Uint8Array(u.bytes);
      k(m.length === r.size);
      const c = Array.from(new Uint8Array(await crypto.subtle.digest("SHA-256", m)), (d) => d.toString(16).padStart(2, "0")).join("");
      return k(c === r.sha256), new Blob([m], { type: r.type });
    }
  };
}
function Ue(e, o, t) {
  x(b(e) && P(o) && P(t, 1) && t <= 100);
}
function $e(e) {
  try {
    return Re(e);
  } catch {
    throw new g("invalid_request");
  }
}
function K(e) {
  const o = N(e);
  if (!o.ok) throw new g("invalid_config");
  return Object.freeze(o.scope);
}
function de(e, o, t, s, a) {
  const n = O(e, a ? ["version", "report", "persisted", "recipientAcknowledged", "replayed"] : ["version", "report"]), r = fe(n.report, (i) => U(o, i).ok ? o : null, t, s);
  return k(n.version === 1 && r !== null), a && k(n.persisted === !0 && n.recipientAcknowledged === !1 && typeof n.replayed == "boolean" && r.reportedBy.id === a.subject && r.reportedBy.issuer === a.issuer), r;
}
function dt(e) {
  const o = K(e.scope);
  if (o.kind !== "client") throw new g("invalid_config");
  const t = Ce(e, "3", o.environmentId);
  return {
    scope: o,
    identity: Object.freeze({ endpoint: e.endpoint, issuer: e.issuer, subject: e.subject, actorKind: "app_user" }),
    attachments: Me(t, e.endpoint),
    async lookupReports(s, a, n) {
      x(b(s) && ye(a));
      const r = Ee(await t({ action: "reports.forMessages", conversationId: s, messageIds: a }, n), (i) => U(o, i).ok ? o : null, s, a);
      return k(r !== null && r.every((i) => i.reportedBy.issuer === e.issuer)), r;
    },
    async createReport(s, a, n, r) {
      const i = G(n);
      x(b(s) && b(a) && i !== null && he(i));
      const u = await t({ action: "reports.create", conversationId: s, requestKey: a, report: i }, r), y = de(u, o, s, void 0, { subject: e.subject, issuer: e.issuer });
      k(JSON.stringify(y.input) === JSON.stringify(i));
      const m = L(u);
      return { version: 1, report: y, persisted: !0, recipientAcknowledged: !1, replayed: m.replayed };
    },
    async readReport(s, a, n) {
      x(b(s) && b(a));
      const r = de(await t({ action: "reports.read", conversationId: s, reportId: a }, n), o, s, a);
      return k(r.reportedBy.issuer === e.issuer), { version: 1, report: r };
    },
    async list(s = null, a = 100, n) {
      x(P(a, 1) && a <= 100);
      const r = $e(s), i = je(await t({ action: "threads.list", cursor: r, limit: a }, n), o.orgId, "app", r, a);
      return k(i.threads.every((u) => U(o, u.scope).ok)), i;
    },
    async open(s, a, n) {
      x(b(s) && M(a, 800));
      const r = O(await t({ action: "threads.open", requestKey: s, title: a }, n), ["version", "conversationId", "scope", "replayed"]);
      return k(r.version === 1 && b(r.conversationId) && U(o, r.scope).ok && typeof r.replayed == "boolean"), { version: 1, conversationId: r.conversationId, scope: o, replayed: r.replayed };
    },
    async read(s, a = 0, n = 100, r) {
      return Ue(s, a, n), Pe(await t({ action: "messages.read", conversationId: s, after: a, limit: n }, r), o, s, "app", a, n);
    },
    async append(s, a, n, r) {
      return x(b(s) && b(a) && M(n)), z(await t({ action: "messages.append", conversationId: s, idempotencyKey: a, body: n }, r), s);
    },
    async acknowledge(s, a, n) {
      x(b(s) && P(a, 1));
      const r = O(
        await t({ action: "messages.acknowledge", conversationId: s, sequence: a }, n),
        ["version", "conversationId", "messageId", "sequence", "recipientAcknowledged", "acknowledgedAt"]
      );
      return k(r.version === 1 && r.conversationId === s && r.sequence === a && b(r.messageId) && r.recipientAcknowledged === !0 && re(r.acknowledgedAt)), {
        version: 1,
        conversationId: s,
        messageId: r.messageId,
        sequence: a,
        recipientAcknowledged: !0,
        acknowledgedAt: r.acknowledgedAt
      };
    }
  };
}
function ut(e) {
  const o = Ce(e, "2");
  return {
    identity: Object.freeze({ endpoint: e.endpoint, issuer: e.issuer, subject: e.subject, actorKind: "orbit_user" }),
    attachments: (t) => Me(o, e.endpoint, K(t)),
    async lookupReports(t, s, a, n) {
      const r = K(t);
      x(b(s) && ye(a));
      const i = Ee(await o({ action: "reports.forMessages", scope: r, conversationId: s, audience: "app", messageIds: a }, n), (u) => U(r, u).ok ? r : null, s, a);
      return k(i !== null), i;
    },
    async readReport(t, s, a, n) {
      const r = K(t);
      return x(b(s) && b(a)), { version: 1, report: de(await o({ action: "reports.read", scope: r, conversationId: s, audience: "app", reportId: a }, n), r, s, a) };
    },
    async list(t, s = "app", a = null, n = 100, r) {
      x(b(t) && (s === "app" || s === "internal") && P(n, 1) && n <= 100);
      const i = $e(a);
      return je(await o({ action: "threads.list", orgId: t, audience: s, cursor: i, limit: n }, r), t, s, i, n);
    },
    async read(t, s, a = "app", n = 0, r = 100, i) {
      const u = K(t);
      return Ue(s, n, r), x(a === "app" || a === "internal"), Pe(await o({ action: "messages.read", scope: u, conversationId: s, audience: a, after: n, limit: r }, i), u, s, a, n, r);
    },
    async append(t, s, a, n, r, i) {
      return x(b(s) && b(n) && M(r) && (a === "app" || a === "internal")), z(await o({ action: "messages.append", scope: K(t), conversationId: s, audience: a, idempotencyKey: n, body: r }, i), s);
    },
    async delivery(t, s, a, n) {
      x(b(s) && b(a));
      const r = O(
        await o({ action: "messages.delivery", scope: K(t), conversationId: s, messageId: a, audience: "app" }, n),
        ["version", "conversationId", "messageId", "recipientAcknowledged", "acknowledgedRecipientCount", "acknowledgedAt"]
      );
      return k(r.version === 1 && r.conversationId === s && r.messageId === a && P(r.acknowledgedRecipientCount) && r.recipientAcknowledged === r.acknowledgedRecipientCount > 0 && (r.acknowledgedRecipientCount === 0 ? r.acknowledgedAt === null : re(r.acknowledgedAt))), {
        version: 1,
        conversationId: s,
        messageId: a,
        recipientAcknowledged: r.recipientAcknowledged,
        acknowledgedRecipientCount: r.acknowledgedRecipientCount,
        acknowledgedAt: r.acknowledgedAt
      };
    }
  };
}
class _ extends Error {
  constructor(o) {
    super(`Orbit support: ${o}`), this.code = o, this.name = "SupportOutboxError";
  }
}
const Qe = "orbit-support-outbox-v1", Q = "replies", Y = "requests", J = "orbit-support-outbox-change", ee = 10080 * 60 * 1e3, te = 100;
function we(e) {
  if (!/^https:\/\/[a-z]{20}\.supabase\.co\/functions\/v1\/(?:orbit-bridge|orbit-tenant-support)$/.test(e.endpoint) || !/^https:\/\/[a-z]{20}\.supabase\.co\/auth\/v1$/.test(e.issuer) || !b(e.subject) || e.actorKind !== "orbit_user" && e.actorKind !== "app_user")
    throw new _("outbox_invalid");
  return JSON.stringify([e.endpoint, e.issuer, e.subject]);
}
function V(e) {
  const o = N(e.scope), t = we(e.identity);
  if (!o.ok || !U(o.scope, e.scope).ok || !b(e.conversationId) || e.audience !== "app" && e.audience !== "internal" || e.identity.actorKind === "app_user" && (e.audience !== "app" || o.scope.kind !== "client")) throw new _("outbox_invalid");
  return { account: t, key: JSON.stringify([t, e.identity.actorKind, o.scope, e.conversationId, e.audience]) };
}
function ae(e) {
  const o = N(e.scope), t = we(e.identity);
  if (!o.ok || o.scope.kind !== "client" || e.identity.actorKind !== "app_user") throw new _("outbox_invalid");
  return { account: t, key: JSON.stringify([t, "app_user", o.scope, "new-request"]) };
}
function Ye(e, o, t) {
  if (e === void 0) return null;
  try {
    const s = L(e), a = ["version", "key", "account", "requestKey", "createdAt", "expiresAt", "state", "title", "body", "conversationId", "receipt"], n = O(s, s.version === 1 ? a : [...a, "report", "reportId"]);
    if (n.version !== 1 && n.version !== 2 || n.key !== o || n.account !== t || !b(n.requestKey) || !P(n.createdAt, 1) || !P(n.expiresAt, n.createdAt + 1)) throw new Error();
    const r = { version: 2, key: o, account: t, requestKey: n.requestKey, createdAt: n.createdAt, expiresAt: n.expiresAt }, i = n.version === 1 || n.report === null ? null : G(n.report), u = n.version === 1 ? null : n.reportId;
    if (n.version === 2 && n.report !== null && i === null) throw new Error();
    if (i !== null && (n.title !== i.title || n.body !== le(i) || !he(i))) throw new Error();
    if (n.state !== "submitted" && u !== null) throw new Error();
    if (n.state === "opening" && M(n.title, 800) && M(n.body) && n.conversationId === null && n.receipt === null)
      return { ...r, state: "opening", title: n.title, body: n.body, conversationId: null, receipt: null, report: i, reportId: null };
    if (n.state === "opened" && M(n.title, 800) && M(n.body) && b(n.conversationId) && n.receipt === null)
      return { ...r, state: "opened", title: n.title, body: n.body, conversationId: n.conversationId, receipt: null, report: i, reportId: null };
    if (n.state === "submitted" && n.title === null && n.body === null && i === null && (u === null || b(u)) && b(n.conversationId))
      return { ...r, state: "submitted", title: null, body: null, conversationId: n.conversationId, receipt: z(n.receipt, n.conversationId), report: null, reportId: typeof u == "string" ? u : null };
    throw new Error();
  } catch {
    throw new _("outbox_invalid");
  }
}
function Be(e, o, t, s) {
  if (e === void 0) return null;
  try {
    const a = O(e, ["version", "key", "account", "idempotencyKey", "createdAt", "expiresAt", "state", "body", "receipt"]);
    if (a.version !== 1 || a.key !== o || a.account !== t || !b(a.idempotencyKey) || !P(a.createdAt, 1) || !P(a.expiresAt, a.createdAt + 1)) throw new Error();
    const n = { version: 1, key: o, account: t, idempotencyKey: a.idempotencyKey, createdAt: a.createdAt, expiresAt: a.expiresAt };
    if (a.state === "pending" && M(a.body) && a.receipt === null) return { ...n, state: "pending", body: a.body, receipt: null };
    if (a.state === "saved" && a.body === null) return { ...n, state: "saved", body: null, receipt: z(a.receipt, s) };
    throw new Error();
  } catch {
    throw new _("outbox_invalid");
  }
}
function et(e, o) {
  try {
    const t = L(e);
    if (typeof t.key != "string") return null;
    const s = JSON.parse(t.key);
    if (!Array.isArray(s) || s.length !== 5 || s[1] !== "orbit_user" && s[1] !== "app_user" || !b(s[3]) || s[4] !== "app" && s[4] !== "internal") return null;
    const a = N(s[2]);
    if (!a.ok) return null;
    const { key: n, account: r } = V({ identity: { ...o, actorKind: s[1] }, scope: a.scope, conversationId: s[3], audience: s[4] }), i = Be(e, n, r, s[3]);
    return (i == null ? void 0 : i.state) === "saved" ? i : null;
  } catch {
    return null;
  }
}
function tt(e = globalThis.indexedDB) {
  let o, t = !1, s;
  const a = () => t || !e ? Promise.reject(new _("outbox_unavailable")) : (o || (o = new Promise((c, d) => {
    const p = e.open(Qe, 3);
    let f = !1;
    const h = () => {
      f = !0, d(new _("outbox_unavailable"));
    }, l = setTimeout(h, 5e3);
    p.onupgradeneeded = () => {
      var w;
      if (f) {
        (w = p.transaction) == null || w.abort();
        return;
      }
      for (const v of [Q, Y]) p.result.objectStoreNames.contains(v) || p.result.createObjectStore(v, { keyPath: "key" }).createIndex("account", "account", { unique: !1 });
    }, p.onerror = p.onblocked = () => {
      clearTimeout(l), h();
    }, p.onsuccess = () => {
      clearTimeout(l);
      const w = p.result;
      if (t || f) {
        w.close(), h();
        return;
      }
      w.onversionchange = () => {
        w.close(), t = !0;
      }, c(w);
    };
  }).catch(() => {
    throw o = void 0, new _("outbox_unavailable");
  })), o), n = (c, d) => {
    const p = { account: c, key: d };
    typeof globalThis.dispatchEvent == "function" && globalThis.dispatchEvent(new CustomEvent(J, { detail: p })), typeof BroadcastChannel < "u" && (s ?? (s = new BroadcastChannel(J)), s.postMessage(p));
  }, r = async (c, d, p = Q) => {
    const f = await a();
    return new Promise((h, l) => {
      let w;
      try {
        w = f.transaction(p, c, { durability: "strict" });
      } catch {
        l(new _("outbox_unavailable"));
        return;
      }
      let v, I = !1, S;
      const A = (T) => {
        S = T;
        try {
          w.abort();
        } catch {
          l(T);
        }
      }, q = setTimeout(() => A(new _("outbox_unavailable")), 1e4);
      w.oncomplete = () => {
        clearTimeout(q), I ? h(v) : l(new _("outbox_unavailable"));
      }, w.onabort = w.onerror = () => {
        clearTimeout(q), l(S instanceof _ ? S : new _("outbox_unavailable"));
      };
      try {
        d(w.objectStore(typeof p == "string" ? p : p[0]), (T) => {
          v = T, I = !0;
        }, A, w);
      } catch (T) {
        A(T);
      }
    });
  }, i = async (c, d, p) => {
    const { account: f, key: h } = V(c);
    return r(d, (l, w, v) => {
      const I = l.get(h);
      I.onsuccess = () => {
        try {
          p(Be(I.result, h, f, c.conversationId), l, w, v);
        } catch (S) {
          v(S);
        }
      };
    });
  }, u = async (c, d, p) => {
    const { account: f, key: h } = ae(c);
    return r(d, (l, w, v) => {
      const I = l.get(h);
      I.onsuccess = () => {
        try {
          p(Ye(I.result, h, f), l, w, v);
        } catch (S) {
          v(S);
        }
      };
    }, Y);
  }, y = (c, d, p) => {
    const f = (w) => {
      w && typeof w == "object" && "account" in w && w.account === c && (!("key" in w) || w.key === void 0 || w.key === d) && p();
    }, h = (w) => f(w.detail);
    globalThis.addEventListener(J, h);
    const l = typeof BroadcastChannel < "u" ? new BroadcastChannel(J) : null;
    return l && (l.onmessage = (w) => f(w.data)), () => {
      globalThis.removeEventListener(J, h), l == null || l.close();
    };
  }, m = async (c, d, p, f) => {
    if (!M(d, 800) || !(f ? he(f) : Se(c.scope, "0".repeat(36), "app", p, "app_user"))) throw new _("outbox_invalid");
    const { account: h, key: l } = ae(c), w = await u(c, "readwrite", (v, I, S, A) => {
      if (v && v.state !== "submitted") {
        if (v.title !== d || v.body !== p || JSON.stringify(v.report) !== JSON.stringify(f)) throw new _("outbox_conflict");
        if (v.expiresAt <= Date.now()) throw new _("outbox_expired");
        S(v);
        return;
      }
      const q = I.index("account").count(h);
      q.onsuccess = () => {
        try {
          if (!v && q.result >= te) throw new _("outbox_limit");
          const T = Date.now(), R = {
            version: 2,
            key: l,
            account: h,
            requestKey: crypto.randomUUID(),
            createdAt: T,
            expiresAt: T + ee,
            state: "opening",
            title: d,
            body: p,
            conversationId: null,
            receipt: null,
            report: f,
            reportId: null
          };
          I.put(R), S(R);
        } catch (T) {
          A(T);
        }
      };
    });
    return n(h, l), w;
  };
  return {
    readThread: (c) => u(c, "readonly", (d, p, f) => f(d)),
    subscribeThread(c, d) {
      const { account: p, key: f } = ae(c);
      return y(p, f, d);
    },
    prepareThread: (c, d, p) => m(c, d, p, null),
    prepareReportThread(c, d) {
      const p = G(d);
      if (!p) throw new _("outbox_invalid");
      return m(c, p.title, le(p), p);
    },
    async markThreadOpened(c, d, p) {
      const f = O(p, ["version", "conversationId", "scope", "replayed"]);
      if (f.version !== 1 || !b(f.conversationId) || !U(c.scope, f.scope).ok || typeof f.replayed != "boolean") throw new _("outbox_invalid");
      const h = await u(c, "readwrite", (l, w, v) => {
        if (!l || l.requestKey !== d || l.conversationId !== null && l.conversationId !== f.conversationId) throw new _("outbox_conflict");
        if (l.state !== "opening") {
          v(l);
          return;
        }
        const I = { ...l, state: "opened", conversationId: f.conversationId };
        w.put(I), v(I);
      });
      return n(h.account, h.key), h;
    },
    async markThreadSubmitted(c, d, p) {
      const f = await u(c, "readwrite", (h, l, w) => {
        if (!h || h.requestKey !== d || h.conversationId === null || h.report !== null || h.reportId !== null) throw new _("outbox_conflict");
        const v = z(p, h.conversationId);
        if (h.state === "submitted") {
          if (h.receipt.messageId !== v.messageId || h.receipt.sequence !== v.sequence) throw new _("outbox_conflict");
          w(h);
          return;
        }
        const I = { ...h, state: "submitted", body: null, title: null, receipt: v, report: null, reportId: null };
        l.put(I), w(I);
      });
      return n(f.account, f.key), f;
    },
    async markThreadReportSubmitted(c, d, p) {
      const f = O(p, ["version", "report", "persisted", "recipientAcknowledged", "replayed"]), h = await u(c, "readwrite", (l, w, v) => {
        if (!l || l.requestKey !== d || l.conversationId === null) throw new _("outbox_conflict");
        const I = fe(f.report, (q) => U(c.scope, q).ok ? c.scope : null, l.conversationId);
        if (!I || f.version !== 1 || f.persisted !== !0 || f.recipientAcknowledged !== !1 || typeof f.replayed != "boolean" || I.reportedBy.id !== c.identity.subject || I.reportedBy.issuer !== c.identity.issuer) throw new _("outbox_invalid");
        const S = { version: 1, conversationId: I.conversationId, messageId: I.messageId, sequence: I.sequence, persisted: !0, recipientAcknowledged: !1, replayed: f.replayed };
        if (l.state === "submitted") {
          if (l.reportId !== I.reportId || l.receipt.messageId !== I.messageId || l.receipt.sequence !== I.sequence) throw new _("outbox_conflict");
          v(l);
          return;
        }
        if (l.report === null || JSON.stringify(l.report) !== JSON.stringify(I.input)) throw new _("outbox_conflict");
        const A = { ...l, state: "submitted", title: null, body: null, report: null, reportId: I.reportId, receipt: S };
        w.put(A), v(A);
      });
      return n(h.account, h.key), h;
    },
    async renewThread(c, d) {
      const p = await u(c, "readwrite", (f, h, l) => {
        if (!f || f.state === "submitted" || f.requestKey !== d) throw new _("outbox_conflict");
        const w = { ...f, expiresAt: Date.now() + ee };
        h.put(w), l(w);
      });
      return n(p.account, p.key), p;
    },
    read: (c) => i(c, "readonly", (d, p, f) => f(d)),
    async prepare(c, d) {
      if (!Se(c.scope, c.conversationId, c.audience, d, c.identity.actorKind)) throw new _("outbox_invalid");
      const { account: p, key: f } = V(c), h = await i(c, "readwrite", (l, w, v, I) => {
        if ((l == null ? void 0 : l.state) === "pending") {
          if (l.body !== d) throw new _("outbox_conflict");
          if (l.expiresAt <= Date.now()) throw new _("outbox_expired");
          v(l);
          return;
        }
        const S = w.index("account").getAll(p, te + 1);
        S.onsuccess = () => {
          try {
            if (!l && S.result.length >= te) {
              if (S.result.length > te) throw new _("outbox_limit");
              const T = S.result.map((R) => et(R, c.identity)).filter((R) => R !== null).sort((R, E) => R.createdAt - E.createdAt)[0];
              if (!T) throw new _("outbox_limit");
              w.delete(T.key);
            }
            const A = Date.now(), q = {
              version: 1,
              key: f,
              account: p,
              idempotencyKey: crypto.randomUUID(),
              createdAt: A,
              expiresAt: A + ee,
              state: "pending",
              body: d,
              receipt: null
            };
            w.put(q), v(q);
          } catch (A) {
            I(A);
          }
        };
      });
      return n(p, f), h;
    },
    async markSaved(c, d, p) {
      const f = z(p, c.conversationId), h = await i(c, "readwrite", (l, w, v) => {
        if (!l || l.idempotencyKey !== d) throw new _("outbox_conflict");
        if (l.state === "saved") {
          if (l.receipt.messageId !== f.messageId || l.receipt.sequence !== f.sequence) throw new _("outbox_conflict");
          v(l);
          return;
        }
        const I = { ...l, state: "saved", body: null, receipt: f };
        w.put(I), v(I);
      });
      return n(h.account, h.key), h;
    },
    async renew(c, d) {
      const p = await i(c, "readwrite", (f, h, l) => {
        if (!f || f.state !== "pending" || f.idempotencyKey !== d) throw new _("outbox_conflict");
        const w = { ...f, expiresAt: Date.now() + ee };
        h.put(w), l(w);
      });
      return n(p.account, p.key), p;
    },
    async discard(c, d) {
      const { account: p, key: f } = V(c);
      await i(c, "readwrite", (h, l, w) => {
        if (h && h.idempotencyKey !== d) throw new _("outbox_conflict");
        h && l.delete(f), w(void 0);
      }), n(p, f);
    },
    async clearAccount(c) {
      const d = we(c);
      await r("readwrite", (p, f, h, l) => {
        let w = 2;
        for (const v of [Q, Y]) {
          const I = l.objectStore(v), S = I.index("account").openKeyCursor(IDBKeyRange.only(d));
          S.onsuccess = () => {
            const A = S.result;
            if (!A) {
              w--, w === 0 && f(void 0);
              return;
            }
            I.delete(A.primaryKey), A.continue();
          };
        }
      }, [Q, Y]), n(d);
    },
    subscribe(c, d) {
      const { account: p, key: f } = V(c);
      return y(p, f, d);
    },
    close() {
      t = !0, s == null || s.close(), o && o.then((c) => c.close(), () => {
      });
    }
  };
}
let nt;
const pt = () => nt ?? (nt = tt()), Oe = (e) => Array.from(e).some((o) => {
  const t = o.codePointAt(0) ?? 0;
  return t < 32 || t === 127;
});
function rt(e) {
  if (!e || typeof e.path != "string") return null;
  const o = e.path.split(/[?#]/, 1)[0];
  if (!o.startsWith("/") || o.startsWith("//") || o.includes("\\") || new TextEncoder().encode(o).length > 500 || Oe(o)) return null;
  const t = e.appVersion;
  return t !== void 0 && (typeof t != "string" || !t.trim() || t !== t.trim() || new TextEncoder().encode(t).length > 100 || Oe(t)) ? null : { path: o, appVersion: t ?? null };
}
function lt(e) {
  const o = rt(e);
  return o ? `Reported page: ${o.path}${o.appVersion ? `
Reported app build: ${o.appVersion}` : ""}` : null;
}
function ft() {
  const e = () => new Promise((n, r) => {
    const i = indexedDB.open("orbit-support-file-outbox", 1);
    i.onupgradeneeded = () => i.result.createObjectStore("files"), i.onsuccess = () => n(i.result), i.onerror = () => r(new g("unavailable")), i.onblocked = () => r(new g("unavailable"));
  }), o = async (n, r) => {
    const i = await e();
    try {
      return await new Promise((u, y) => {
        const m = i.transaction("files", n), c = m.objectStore("files");
        let d;
        m.oncomplete = () => u(d), m.onerror = m.onabort = () => y(new g("unavailable")), r(c, (p) => {
          d = p;
        });
      });
    } finally {
      i.close();
    }
  }, t = (n) => {
    if (n === void 0) return null;
    if (!n || typeof n != "object") throw new g("invalid_response");
    const r = n;
    if (!Object.keys(r).every((i) => ["key", "input", "blob", "createdAt", "resumableUrl"].includes(i)) || !b(r.key) || !B(r.input) || !(r.blob instanceof Blob) || r.blob.size !== r.input.size || typeof r.createdAt != "number" || !Number.isSafeInteger(r.createdAt)) throw new g("invalid_response");
    if (r.resumableUrl !== void 0 && (typeof r.resumableUrl != "string" || r.resumableUrl.length > 2048)) throw new g("invalid_response");
    return r;
  }, s = (n) => {
    if (n === void 0) return [];
    const r = (Array.isArray(n) ? n : [n]).map((i) => {
      const u = t(i);
      if (!u) throw new g("invalid_response");
      return u;
    });
    if (r.length > Ae || new Set(r.map((i) => i.key)).size !== r.length || r.reduce((i, u) => i + u.input.size, 0) > We) throw new g("invalid_response");
    return r;
  };
  return {
    readBatch: (n) => o("readonly", (r, i) => {
      const u = r.get(n);
      u.onsuccess = () => {
        try {
          i(s(u.result));
        } catch {
          r.transaction.abort();
        }
      };
    }),
    prepareBatch: (n, r) => o("readwrite", (i, u) => {
      const y = i.get(n);
      y.onsuccess = () => {
        try {
          if (s(y.result).length) throw new g("conflict");
          if (!r.length || r.length > Ae) throw new g("invalid_request");
          const c = r.map(({ input: d, blob: p }) => ({ key: crypto.randomUUID(), input: d, blob: p, createdAt: Date.now() }));
          s(c), i.put(c, n), u(c);
        } catch {
          i.transaction.abort();
        }
      };
    }),
    checkpoint: (n, r, i) => o("readwrite", (u, y) => {
      const m = u.get(n);
      m.onsuccess = () => {
        try {
          const c = s(m.result);
          if (!c.some((d) => d.key === r) || i.length > 2048) throw new g("conflict");
          u.put(c.map((d) => d.key === r ? { ...d, resumableUrl: i } : d), n), y();
        } catch {
          u.transaction.abort();
        }
      };
    }),
    completeBatchFile: (n, r) => o("readwrite", (i, u) => {
      const y = i.get(n);
      y.onsuccess = () => {
        try {
          const m = s(y.result), c = m.filter((d) => d.key !== r);
          c.length ? i.put(c, n) : i.delete(n), u();
        } catch {
          i.transaction.abort();
        }
      };
    }),
    read: (n) => o("readonly", (r, i) => {
      const u = r.get(n);
      u.onsuccess = () => {
        try {
          i(t(u.result));
        } catch {
          r.transaction.abort();
        }
      };
    }),
    prepare: (n, r, i) => o("readwrite", (u, y) => {
      if (!B(r) || i.size !== r.size) throw new g("invalid_request");
      const m = u.get(n);
      m.onsuccess = () => {
        try {
          const c = t(m.result);
          if (c) {
            if (Object.keys(r).some((p) => r[p] !== c.input[p])) {
              u.transaction.abort();
              return;
            }
            y(c);
            return;
          }
          const d = { key: crypto.randomUUID(), input: r, blob: i, createdAt: Date.now() };
          u.put(d, n), y(d);
        } catch {
          u.transaction.abort();
        }
      };
    }),
    complete: (n, r) => o("readwrite", (i, u) => {
      const y = i.get(n);
      y.onsuccess = () => {
        try {
          const m = t(y.result);
          if (m && m.key !== r) {
            i.transaction.abort();
            return;
          }
          i.delete(n), u();
        } catch {
          i.transaction.abort();
        }
      };
    }),
    clearAccount: (n) => o("readwrite", (r, i) => {
      const u = r.openCursor();
      u.onsuccess = () => {
        const y = u.result;
        if (!y) {
          i();
          return;
        }
        typeof y.key == "string" && y.key.startsWith(n) && y.delete(), y.continue();
      };
    })
  };
}
const ot = "orion-router-v1", st = [
  "orbit.local.status",
  "orbit.task.claim",
  "orbit.task.progress",
  "orbit.task.artifact",
  "orbit.task.complete",
  "orbit.approval.request"
];
function yt(e) {
  return st.includes(e);
}
function ht(e) {
  return {
    id: e.id,
    command_type: e.command_type,
    payload: e.payload,
    target: e.target,
    created_at: e.created_at ?? (/* @__PURE__ */ new Date()).toISOString()
  };
}
function wt(e, o = {}) {
  const { capabilities: t, ...s } = o;
  return {
    runner_id: e,
    protocol_version: ot,
    online: !0,
    checked_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...s,
    capabilities: {
      commands: (t == null ? void 0 : t.commands) ?? !0,
      attachments: (t == null ? void 0 : t.attachments) ?? !0,
      client_requests: (t == null ? void 0 : t.client_requests) ?? !0,
      task_progress: (t == null ? void 0 : t.task_progress) ?? !0,
      approvals: (t == null ? void 0 : t.approvals) ?? !0,
      local_cli: (t == null ? void 0 : t.local_cli) ?? !1,
      orbit_ide: (t == null ? void 0 : t.orbit_ide) ?? !1,
      worktrees: (t == null ? void 0 : t.worktrees) ?? !1
    }
  };
}
export {
  ot as ORBIT_BRIDGE_PROTOCOL_VERSION,
  at as ORBIT_PORTFOLIO_SCOPE_VERSION,
  st as ORION_BRIDGE_COMMAND_TYPES,
  qe as SUPPORT_FILE_LIMIT,
  Ze as SUPPORT_FILE_TYPES,
  ee as SUPPORT_OUTBOX_TTL_MS,
  g as SupportBridgeError,
  _ as SupportOutboxError,
  pt as browserSupportOutbox,
  wt as createLocalStatusPayload,
  ut as createOperatorSupportClient,
  it as createOrbitBridgeClient,
  ht as createOrionBridgeCommand,
  ft as createSupportFileOutbox,
  tt as createSupportOutbox,
  dt as createTenantSupportClient,
  N as decodePortfolioScope,
  G as decodeSupportReportInput,
  le as formatSupportReportMessage,
  yt as isOrionBridgeCommandType,
  U as matchResolvedPortfolioScope,
  ct as supportFileInput,
  lt as supportPageDetails,
  he as supportReportCreateFits,
  rt as supportReportedContext
};
//# sourceMappingURL=orbit-bridge.es.js.map
